import { useState } from 'react'

// local imports
import AuthUtil from 'utils/AuthUtil'
import LactationService from 'service/LactationService'
import { ISaveLactationReservation } from 'types/LactationType'

export default function useSaveLactationRoomReservation(
  resInfo: ISaveLactationReservation,
  closeAfterSave: () => void
) {
  const [loading, setLoading] = useState(false)
  const employeeId = AuthUtil.getEmployeeSummary()?.id

  const saveLactationReservation = () => {
    setLoading(true)
    LactationService.saveLactationRoomReservation({
      ...resInfo,
      id: 0,
      employeeId: employeeId,
      isCancel: false,
    })
      .then((_res) => closeAfterSave())
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }

  return { saveLactationReservation, loading }
}
